import api from './client';

// Enable Banking API
export const enablebankingAPI = {
  getInstitutions: () => api.get('/integrations/enablebanking/institutions'),
  connect: (institutionId, psuType, origin) => api.post('/integrations/enablebanking/connect', null, {
    params: { institution_id: institutionId, psu_type: psuType || 'personal', origin },
  }),
  getStatus: () => api.get('/integrations/enablebanking/status'),
  sync: () => api.post('/integrations/enablebanking/sync'),
  getSyncRunStatus: (runId) => api.get(`/integrations/enablebanking/sync/${runId}`),
  txSync: () => api.post('/integrations/enablebanking/tx-sync'),
  getTxSyncRunStatus: (runId) => api.get(`/integrations/enablebanking/tx-sync/${runId}`),
  relink: (connectionId) => api.post(`/integrations/enablebanking/${connectionId}/relink`),
  relinkPreview: (connectionId) => api.get(`/integrations/enablebanking/${connectionId}/relink/preview`),
  retryFetch: (connectionId) => api.post(`/integrations/enablebanking/${connectionId}/retry-fetch`),
  continuityRepointPreview: () => api.get('/admin/diagnostics/eb-continuity-repoint'),
  continuityRepointApply: () => api.post('/admin/integrations/enablebanking/continuity-repoint'),
};
